export default {
  head_scripts: {
    title: 'Scripts head',
  },
  body_noscripts: {
    title: 'Noscripts body',
    description: "Injecter du code juste après l'ouverture du body",
  },
  google_site_verification: {
    title: 'Vérification du site Google',
    label: 'Code de vérification du site Google',
  },
  buttons: {
    save: 'Enregistrer',
  },
};
